<template>
    <NuxtLayout>
        <div
            data-page
            class="container-extra-wide mx-auto py-20"
        >
            <div class="flex items-center justify-center">
                <div class="flex flex-col items-center justify-center space-y-4">
                    <p class="text-neutral-base leading-sm font-ux text-center text-sm font-semibold">
                        {{ error.statusCode }}
                    </p>
                    <h1 class="leading-5xl font-brand-heading text-heading font-heading text-center text-5xl">
                        {{ error.statusMessage ?? 'Something went wrong' }}
                    </h1>

                    <div
                        v-if="error.message"
                        class="flex max-w-[450px] justify-center text-center"
                    >
                        <p
                            class="leading-base text-base whitespace-pre-wrap text-(--text-body)"
                            v-html="error.message"
                        />
                    </div>

                    <div class="flex w-full justify-center pt-10">
                        <DButton
                            size="lg"
                            @click="handleClearError"
                        >
                            Back to homepage
                        </DButton>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    defineProps({
        error: Object,
    })

    const { homeUri } = storeToRefs(useGlobalStore())

    const handleClearError = async () => {
        await clearError({ redirect: homeUri.value ?? '/' })
    }
</script>
